/**
 * Disclaimer legale — Sezione Europa · Rete dei Comuni Partner.
 * Gazzetta Ufficiale dell'Unione europea C/2012/271/04.
 */

export const EUROPA_LEGAL_GAZETTE_LABEL = "Gazzetta Ufficiale UE 2012/C 271/04";

/** Risorsa ufficiale EUR-Lex — GUUE serie C n. 271/2012 */
export const EUROPA_LEGAL_GAZETTE_URL =
  "https://eur-lex.europa.eu/legal-content/IT/TXT/?uri=OJ:C:2012:271:FULL";
